import { initializeDatepicker } from '../shared/functions';

document.addEventListener('DOMContentLoaded', (): void => {
    document.querySelectorAll<HTMLInputElement>('.date-picker').forEach(($datepicker) => {
        initializeDatepicker($datepicker);
    });
});
